export default __webpack_public_path__ + "static/media/Rani.dcd5b8fe.png";